import { useRef } from "react";
import Navbar from "./components/Navbar";
import Home from "./pages";
import About from "./pages/About";
import FoodDrinkToggle from "./components/FoodDrinkToggle";
import Events from "./pages/Events";
import Disco from "./pages/Disco";
import DrawingBoard from "./components/DrawingBoard";

function Page() {
  const mainRef = useRef(null);

  return (
    <div className="App">
      <Navbar />
      <main ref={mainRef} className="main-content">
        <Home />
        <About />
        <FoodDrinkToggle />
        <Events />
        <Disco />
        <DrawingBoard />
      </main>
    </div>
  );
}

export default Page;
